export default "__VITE_ASSET__COZE_1Nr__"